class CustomStar extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        this.starCount = parseFloat(this.getAttribute('data-star'));
        this.color = this.getAttribute('data-color') || '#F5333F';
        this.renderStars();
    }

    renderStars() {
        const svgs = this.querySelectorAll('svg');
        const fullStars = Math.floor(this.starCount);
        const hasHalfStar = this.starCount % 1 !== 0;
        const totalStars = svgs.length;

        svgs.forEach(svg => {
            const paths = svg.querySelectorAll('path');
            paths.forEach(path => {
                path.style.fill = '';
                path.style.stroke = '';
                path.style.clipPath = '';
                svg.classList.remove('full-star', 'half-star', 'empty-star');
            });
        });

        let index = 0;
        for (; index < fullStars && index < totalStars; index++) {
            const paths = svgs[index].querySelectorAll('path');
            paths.forEach(path => {
                path.style.fill = this.color;
                path.style.stroke = this.color;
            });
            svgs[index].classList.add('full-star');
        }

        if (hasHalfStar && index < totalStars) {
            const paths = svgs[index].querySelectorAll('path');
            paths[0].style.fill = 'none';
            paths[0].style.stroke = this.color;
            paths[1].style.clipPath = 'inset(0 50% 0 0)';
            svgs[index].classList.add('half-star');
            index++;
        }

        for (; index < totalStars; index++) {
            const paths = svgs[index].querySelectorAll('path');
            paths.forEach(path => {
                path.style.fill = 'none';
                path.style.stroke = this.color;
            });
            svgs[index].classList.add('empty-star');
        }
    }
}

customElements.define('custom-star', CustomStar);
